export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
      <h1 className="font-heading text-3xl sm:text-4xl text-stone-900">Privacy Policy</h1>
      <p className="text-stone-600 mt-3">We collect only the information required to fulfil your order: name, phone, delivery address, and (optionally) email. We never sell your data.</p>
      <h2 className="font-heading text-2xl text-stone-900 mt-8">How we use information</h2>
      <p className="text-stone-600 mt-2">Order fulfilment, delivery coordination, and customer support. Nothing more.</p>
      <h2 className="font-heading text-2xl text-stone-900 mt-8">Contact</h2>
      <p className="text-stone-600 mt-2">Privacy concerns? Reach us via the contact page.</p>
    </div>
  );
}
